// @ts-ignore
import base64 from '@gongxigames/framework/core/fragments/WebP/webp.wasm.base64';
import * as decoderBase64 from '@protobufjs/base64';

export type ParserWebP = (img: Uint8Array) => ImageData;

let parserFunction: ParserWebP | null = null;

const stubs = {
    fd_close(): void {
        throw new Error('Syscall fd_close not implemented');
    },
    fd_seek(): void {
        throw new Error('Syscall fd_seek not implemented');
    },
    fd_write(): void {
        throw new Error('Syscall fd_write not implemented');
    }
};

export function getParserWebP(): Promise<ParserWebP> {
    if (parserFunction) {
        return Promise.resolve(parserFunction);
    }

    const bytes = new Uint8Array(decoderBase64.length(base64));

    decoderBase64.decode(base64, bytes, 0);

    return WebAssembly
        .compile(bytes)
        .then(wasmModule => WebAssembly.instantiate(wasmModule, { wasi_snapshot_preview1: stubs }))
        .then(instance => {
            parserFunction = function(input: Uint8Array): ImageData {
                // Allocate memory to hand over the input data to WASM
                // @ts-ignore
                const inputPointer = instance.exports.malloc(input.byteLength);
                // @ts-ignore
                const targetView = new Uint8Array(instance.exports.memory.buffer, inputPointer, input.byteLength);

                // Copy input data into WASM readable memory
                targetView.set(input);

                // Allocate metadata (width & height)
                // @ts-ignore
                const metadataPointer = instance.exports.malloc(8);

                // Decode input data
                // @ts-ignore
                const outputPointer = instance.exports.WebPDecodeRGBA(inputPointer, input.byteLength, metadataPointer, metadataPointer + 4);

                // Free the input data in WASM land
                // @ts-ignore
                instance.exports.free(inputPointer);

                // Guard return value for NULL pointer
                if (outputPointer === 0) {
                    // @ts-ignore
                    instance.exports.free(metadataPointer);
                    throw new Error('Failed to decode WebP image');
                }

                // Read returned metadata
                // @ts-ignore
                const metadata = new Uint32Array(instance.exports.memory.buffer, metadataPointer, 2);
                const width = metadata[0];
                const height = metadata[1];

                // Free the metadata in WASM land
                // @ts-ignore
                instance.exports.free(metadataPointer);

                // Create an empty buffer for the resulting data
                const outputSize = (width * height * 4);
                const output = new Uint8ClampedArray(outputSize);

                // Copy decoded data from WASM memory to JS
                // @ts-ignore
                output.set(new Uint8Array(instance.exports.memory.buffer, outputPointer, outputSize));

                // Free WASM copy of decoded data
                // @ts-ignore
                instance.exports.free(outputPointer);

                // Return decoded image as raw data
                return new ImageData(output, width, height);
            };

            return parserFunction;
        });
}
